import { createSelector } from "reselect";
import getRequireVerseThree from "selectors/loading/getRequireVerseThree";
import getNeedsDashJs from "selectors/getNeedsDashJs";

const getVerseThreeLoaded = (state) => state.loading.verseThreeLoadComplete;
const getStory = (state) => state.story;
const getDashJsLoaded = (state) => state.loading.dashJsLoadComplete;

export default createSelector(
  getDashJsLoaded,
  getNeedsDashJs,
  getRequireVerseThree,
  getStory,
  getVerseThreeLoaded,
  (dashJsLoaded, needsDashJs, requireVerseThree, story, verseThreeLoaded) => {
    if (!story) {
      // wait to evaluate until data is present.
      return true;
    }

    if (requireVerseThree && !verseThreeLoaded) {
      return true;
    }

    if (needsDashJs && !dashJsLoaded) {
      return true;
    }

    return false;
  },
);
